import { render, staticRenderFns } from "./auditDetails.vue?vue&type=template&id=0cb3c4b2&scoped=true"
import script from "./auditDetails.vue?vue&type=script&lang=js"
export * from "./auditDetails.vue?vue&type=script&lang=js"
import style0 from "./auditDetails.vue?vue&type=style&index=0&id=0cb3c4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3c4b2",
  null
  
)

export default component.exports